<template>
  <div>
    <b-modal
        :id="toolModalId"
        modal-class="guide-modal"
        hide-footer
        hide-header
        centered
        size="lg"
        @shown="handleModalOpened"
    >
      <template v-if="formTool">
        <div v-if="mode!=='del'" class="add-tool" >
          <span  @click="handleCancel" class="close-icon">
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
              <g clip-path="url(#clip0)">
                <path
                    d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                    fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                      width="10.6667"
                      height="10.6667"
                      fill="white"
                      transform="translate(6.6665 6.66675)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <h3>{{ add ? "" : "Edit" }} {{ formTool.name ? formTool.name : 'MyApp'}} Info </h3>
          <div class="h-18"></div>

          <b-tabs content-class="mt-3">
            <b-tab title="Basic Info" active>
              <div id="tool-basic-info">
                <!-- Name -->
                <b-form-group label="Name">
                  <b-form-input
                      v-model="formTool.name"
                      type="text"
                      required
                      placeholder="Enter Name"
                  />
                </b-form-group>
                <!-- Insired By -->
                <b-form-group label="Profile Name and Name Id">
                  <b-form-input
                      v-model="formTool.profileNameId"
                      type="text"
                      required
                      placeholder="cardgame"
                  />
                </b-form-group>
                <!-- Insired By -->
                <b-form-group label="Inspired By">
                  <b-form-input
                      v-model="formTool.inspiredBy"
                      type="text"
                      required
                      placeholder="Steve Jobs"
                  />
                </b-form-group>
                <!-- Description -->
                <b-form-group label="Description" label-for="description">
                  <b-form-textarea
                      id="description"
                      v-model="formTool.description"
                      placeholder="Description"
                      rows="2"
                      no-resize
                  />
                </b-form-group>

                <!-- Version -->
                <b-form-group label="Version Details">
                  <div class="inline-form">
                    <b-form-input
                        class="col-5"
                        v-model="formTool.versionNumber"
                        type="text"
                        required
                        placeholder="Version Number"
                    />
                    <b-form-input
                        class="col-5"
                        v-model="formTool.versionHistory"
                        type="text"
                        required
                        placeholder="Version History"
                    />
                  </div>
                </b-form-group>
                <!--- Tool Info (Rating, Rating Level, Price) -->
                <b-form-group label="Tool Info">
                  <div class="inline-form">
                    <b-form-input
                        class="col-3"
                        v-model="formTool.rating"
                        type="text"
                        required
                        placeholder="Rating"
                    />
                    <b-form-input
                        class="col-3"
                        v-model="formTool.ratingLevel"
                        type="text"
                        required
                        placeholder="Rating Level"
                    />
                    <b-form-input
                        class="col-3"
                        v-model="formTool.price"
                        type="text"
                        required
                        placeholder="Price"
                    />
                  </div>
                </b-form-group>
                <!-- Company -->
                <b-form-group label="Company" label-for="companiesDropdown">
                  <b-dropdown
                      block
                      variant="primary"
                      ref="companiesDropdown"
                      id="companiesDropdown"
                      :text="getCompanyText()"
                  >
                    <div v-for="(company, i) in allCompanies" :key="i">
                      <div
                          @click="associateCompany(company)"
                          class="companies"
                          :class="
                    formTool.company &&
                    formTool.company.companyId == company.companyId
                      ? 'active'
                      : ''
                  "
                      >
                        <img
                            v-if="company.company && company.company.imgURL"
                            :src="company.company.imgURL"
                            class="company-image"
                            alt="Company Image"
                        />
                        <b-avatar v-else></b-avatar>
                        <span
                            class="mr-2"
                            v-if="company.company && company.company.name"
                        >
                    {{ company.company.name }}
                  </span>
                        <span v-else>{{ company.companyId }}</span>
                      </div>
                    </div>
                  </b-dropdown>
                </b-form-group>
                <!-- Tool Icon -->
                <b-form-group label="Tool Icon">
                  <img
                      v-if="formTool.imgURL"
                      class="tool-image"
                      :src="formTool.imgURL"
                      alt="Tool Icon"
                  />
                  <b-button
                      variant="primary btn-round-fill upload-btn"
                      :disabled="uploadingIcon"
                      @click="uploadIcon"
                  >
              <span v-if="uploadingIcon">
                <b-spinner class="mr-1" small></b-spinner> Uploading...
              </span>
                    <span v-else>
                <span v-if="formTool.imgURL">
                  Update Icon
                </span>
                <span v-else>
                  Upload Icon
                </span>
              </span>
                  </b-button>
                </b-form-group>
                <!-- Tool Images -->
                <b-form-group label="Upload Tool Images">
                  <b-button
                      variant="primary btn-round-fill upload-btn"
                      @click="uploadScreen"
                  >
              <span v-if="uploadingScreen">
                <b-spinner class="mr-1" small></b-spinner> Uploading...
              </span>
                    <span v-else>
                Upload Image
              </span>
                  </b-button>
                  <div class="tool-images">
                    <img
                        v-for="(image, index) in formTool.images"
                        :key="index"
                        :src="image"
                        class="tool-image"
                        alt="Tool Image"
                    />
                  </div>
                </b-form-group>
                <my-upload
                    langType="en"
                    field="img"
                    @crop-success="cropSuccess"
                    @crop-upload-success="cropUploadSuccess"
                    @crop-upload-fail="cropUploadFail"
                    v-model="showUpload"
                    :width="300"
                    :height="300"
                    :params="params"
                    :headers="headers"
                    img-format="png"
                    :noSquare="true"
                >
                </my-upload>
                <!--Tool Videos -->
                <b-form-group label="Upload Tool Video">
                  <img
                      v-if="formTool.video && formTool.video.videoThumb"
                      :src="formTool.video.videoThumb"
                      alt="Tool-Video"
                      class="tool-video"
                      @click="playToolVideo"
                  />
                  <b-button
                      variant="primary btn-round-fill upload-btn"
                      :disabled="uploadingVideo || processingVideo"
                      @click="triggerChooseVideo"
                  >
              <span v-if="uploadingVideo || processingVideo">
                <b-spinner class="mr-1" small></b-spinner>
                <span v-if="uploadingVideo">
                  Uploading...
                </span>
                <span v-else>
                  Processing...
                </span>
              </span>
                    <span v-else>
                <span v-if="formTool.video">
                  Update Video
                </span>
                <span v-else>
                  Upload Video
                </span>
              </span>
                  </b-button>
                  <input id="tool-video" type="file" @change="uploadToolVideo" />
                </b-form-group>
                <!--Focus AReas -->
                <b-form-group label="Select Focus Areas">
                  <div class="areas">
                    <div class="spiritual">
                      <h6>Spiritual</h6>
                      <svg
                          @click="toggleSphere('s')"
                          width="31"
                          height="31"
                          viewBox="0 0 31 31"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M15.5 31C24.0604 31 31 24.0604 31 15.5C31 6.93959 24.0604 0 15.5 0C6.93958 0 0 6.93959 0 15.5C0 24.0604 6.93958 31 15.5 31Z"
                            :fill="
                      formTool &&
                      formTool.spheres &&
                      formTool.spheres.includes('s')
                        ? 'var(--theme-color)'
                        : '#ddd'
                    "
                        />
                        <path
                            d="M16.8568 7.25651C16.7516 7.25492 16.6502 7.29588 16.5764 7.37083L14.5994 9.3367C14.5274 9.40868 14.4614 9.48604 14.395 9.56309C13.6597 8.95221 12.7373 8.60899 11.7789 8.60976H10.8973C10.6823 8.60976 10.5052 8.78694 10.5052 9.00196V10.5052H9.00191C8.78689 10.5052 8.61013 10.682 8.61013 10.897V11.7786C8.61021 12.0739 8.65073 12.3671 8.71363 12.6555C8.44879 12.8217 8.19786 13.01 7.97689 13.2314L7.3712 13.8371C7.2192 13.9891 7.2192 14.2391 7.3712 14.3911L9.36256 16.3828C9.4328 16.4531 9.50822 16.5171 9.58306 16.5816C8.95993 17.3204 8.60936 18.252 8.61013 19.2211V20.1026C8.61015 20.3176 8.78689 20.4944 9.00191 20.4944H10.5052V21.9977C10.5052 22.2127 10.6824 22.3898 10.8974 22.3898H11.7789C12.0865 22.3898 12.3914 22.3462 12.6912 22.2781C12.8553 22.5379 13.0405 22.7844 13.258 23.0017L13.8657 23.6252C13.9386 23.7001 14.0385 23.7426 14.1431 23.7434H14.1456C14.2491 23.7434 14.3487 23.7024 14.4221 23.6294L16.4001 21.6629V21.6627C16.4719 21.5906 16.5379 21.5134 16.6042 21.4363C17.3397 22.0475 18.2619 22.3907 19.2207 22.3899H20.1021C20.3172 22.3899 20.4943 22.2128 20.4943 21.9977V20.4945H21.9976C22.2127 20.4945 22.3894 20.3177 22.3894 20.1027V19.2208C22.3894 18.9255 22.3488 18.6325 22.2859 18.3442C22.5507 18.178 22.8013 17.9899 23.0223 17.7685L23.6283 17.1625C23.7804 17.0105 23.7804 16.7603 23.6283 16.6082L21.6369 14.6165C21.5667 14.5464 21.4913 14.4825 21.4165 14.418C22.0396 13.6792 22.3902 12.7477 22.3894 11.7787V10.8971C22.3894 10.6821 22.2127 10.5053 21.9976 10.5053H20.4943V9.00194C20.4943 8.78692 20.3172 8.60983 20.1021 8.60983H19.2207C18.9131 8.60986 18.6077 8.65337 18.308 8.72155C18.1442 8.46208 17.9596 8.21605 17.7425 7.99895L17.7406 7.99768L17.1329 7.37431C17.0601 7.29954 16.9602 7.25732 16.8558 7.25635L16.8568 7.25651ZM16.8489 8.20525L17.183 8.54787L17.1859 8.55072C18.4849 9.85272 18.4848 11.9568 17.1859 13.2589L16.8058 13.6389C16.5318 13.446 16.2213 13.317 15.8912 13.2591V12.7229C15.8912 11.7705 15.5541 10.8533 14.95 10.1199C15.0151 10.0417 15.0806 9.96392 15.1525 9.89192V9.89165L16.8489 8.20525ZM11.2887 9.39373H11.7782C13.6175 9.39563 15.1054 10.8837 15.1074 12.723V13.2616C14.2636 13.4116 13.5855 14.0165 13.3319 14.8326C12.1048 14.3109 11.2922 13.1198 11.2887 11.7786V11.7783V9.39373ZM19.2207 9.39373H19.7105V10.5052H19.2207C19.1198 10.5053 19.0191 10.5132 18.9186 10.5206C18.8849 10.1539 18.8001 9.79533 18.67 9.45102C18.8524 9.42046 19.0356 9.39378 19.2207 9.39373V9.39373ZM9.39369 11.2888H10.5049V11.7786C10.5049 11.8708 10.5121 11.9612 10.5183 12.0518C10.1505 12.0835 9.79054 12.1665 9.4448 12.2955C9.41791 12.1242 9.39381 11.9521 9.39373 11.7786L9.39369 11.2888ZM19.2207 11.2888H21.6055V11.7786C21.6036 13.6178 20.1158 15.1056 18.2766 15.1078H17.74C17.6822 14.7777 17.5536 14.467 17.3606 14.1929L17.74 13.8135V13.8132C18.4156 13.1413 18.826 12.2534 18.917 11.3072C19.0179 11.2979 19.119 11.289 19.2203 11.2889L19.2207 11.2888ZM10.6523 12.8262C10.9054 13.7741 11.4905 14.5876 12.2922 15.1452C11.5056 15.2281 10.7597 15.5294 10.1432 16.0297C10.0654 15.9651 9.98817 15.8999 9.9165 15.8285L8.20228 14.1139L8.53112 13.785C9.09703 13.2148 9.85237 12.8789 10.652 12.8262H10.6523ZM15.5053 13.9926C15.5587 13.9932 15.6119 13.9969 15.6647 14.0032C15.8056 14.0201 15.9437 14.0567 16.0748 14.111C16.5994 14.3282 17.0029 14.8248 17.0029 15.4997C17.001 16.3309 16.3309 17.0018 15.4997 17.003C14.8248 17.003 14.3279 16.5998 14.1106 16.0752C13.8933 15.5506 13.9595 14.9141 14.4366 14.437C14.7497 14.1239 15.1316 13.9877 15.5053 13.9926V13.9926ZM20.856 14.9699H20.8561C20.9338 15.0346 21.011 15.0997 21.0827 15.1711L22.7973 16.8854L22.4681 17.2145C21.9021 17.7846 21.1468 18.1207 20.3473 18.1734C20.0942 17.2256 19.509 16.4121 18.7074 15.8544C19.494 15.7715 20.2397 15.4702 20.8563 14.9699H20.856ZM12.7226 15.8918H12.7227H13.2589C13.3168 16.2219 13.4457 16.5324 13.6386 16.8064L13.2592 17.1861C12.5834 17.858 12.1729 18.7458 12.0819 19.6921C11.9809 19.7015 11.8797 19.7103 11.7782 19.7105H9.39369V19.221C9.39559 17.3819 10.8835 15.8941 12.7226 15.8918V15.8918ZM17.6673 16.1669C18.8946 16.6887 19.7072 17.8797 19.7105 19.2211V21.6059H19.2207C17.3814 21.604 15.8935 20.116 15.8914 18.2766V17.7381C16.7354 17.5882 17.4137 16.9831 17.6673 16.1669ZM14.1929 17.3607C14.467 17.5536 14.7776 17.6825 15.1078 17.7403V18.2766C15.1078 19.2289 15.4448 20.1459 16.0486 20.8793C15.9837 20.9576 15.9183 21.0355 15.8465 21.1076L14.1503 22.7944L13.8145 22.4498C13.8145 22.4501 13.8145 22.4491 13.8145 22.4495V22.4492V22.4489C12.5134 21.1478 12.5134 19.042 13.8145 17.7409L14.1929 17.3607ZM21.5544 18.7038C21.5813 18.8752 21.6054 19.0474 21.6055 19.2211V19.7105H20.4944V19.2211C20.4944 19.1287 20.4871 19.0382 20.4809 18.9475C20.8488 18.9159 21.2085 18.8328 21.5543 18.7038H21.5544ZM12.0806 20.479C12.1143 20.8456 12.1987 21.2042 12.3288 21.5485C12.1466 21.5791 11.9635 21.6059 11.7785 21.6059H11.2888V20.4944H11.7785C11.8794 20.4943 11.9801 20.4863 12.0806 20.4789V20.479Z"
                            fill="white"
                        />
                      </svg>
                    </div>
                    <div class="health">
                      <h6>Health</h6>
                      <svg
                          @click="toggleSphere('h')"
                          width="31"
                          height="31"
                          viewBox="0 0 31 31"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M15.5 31C24.0604 31 31 24.0604 31 15.5C31 6.93959 24.0604 0 15.5 0C6.93959 0 0 6.93959 0 15.5C0 24.0604 6.93959 31 15.5 31Z"
                            :fill="
                      formTool &&
                      formTool.spheres &&
                      formTool.spheres.includes('h')
                        ? '#FF8C7D'
                        : '#ddd'
                    "
                        />
                        <path
                            d="M11.7163 7.92725C10.4068 7.92725 9.20456 8.45094 8.32717 9.40254C7.46019 10.343 6.98157 11.6289 6.98157 13.0251C6.98157 14.4615 7.51479 15.7744 8.66947 17.1677C9.70254 18.4142 11.1926 19.6848 12.9201 21.157C12.921 21.1577 12.922 21.1585 12.9229 21.1593C13.5122 21.6614 14.1799 22.231 14.8729 22.837C15.0462 22.9888 15.2686 23.072 15.4994 23.072C15.73 23.072 15.9527 22.9885 16.1258 22.837C16.8204 22.2295 17.4891 21.6595 18.0793 21.1566C19.8066 19.6845 21.2965 18.4139 22.3296 17.1673C23.4843 15.7741 24.0179 14.4615 24.0179 13.0251C24.0179 11.6289 23.5392 10.343 22.6722 9.40254C21.7949 8.45094 20.5925 7.92725 19.2831 7.92725C18.305 7.92725 17.4115 8.23585 16.6225 8.84606C16.2242 9.15407 15.863 9.53126 15.5441 9.97199C15.539 9.97904 15.5323 9.98476 15.5245 9.98871C15.5167 9.99267 15.5081 9.99473 15.4993 9.99473C15.4906 9.99473 15.482 9.99267 15.4742 9.98871C15.4665 9.98476 15.4597 9.97904 15.4545 9.97199C15.1358 9.53126 14.7747 9.15407 14.3766 8.84606C13.5876 8.23586 12.6941 7.92725 11.716 7.92725H11.7163ZM11.7163 8.82091C12.4902 8.82091 13.2031 9.06806 13.8299 9.55266C14.3887 9.98484 14.7755 10.5286 15.0026 10.9093C15.1085 11.0868 15.2933 11.1918 15.4997 11.1918C15.7061 11.1918 15.8909 11.0868 15.9968 10.9093C16.224 10.5286 16.6108 9.98484 17.1695 9.55266C17.7962 9.06806 18.5091 8.82091 19.283 8.82091C20.3381 8.82091 21.31 9.2429 22.0155 10.0081C22.7315 10.7849 23.1245 11.8567 23.1245 13.0251C23.1245 14.2586 22.6636 15.3649 21.6422 16.5974C20.6547 17.789 19.1921 19.0345 17.5004 20.4763C16.9078 20.9811 16.2364 21.5535 15.5347 22.1646C15.5245 22.1734 15.5116 22.1783 15.4981 22.1783C15.4847 22.1783 15.4717 22.1734 15.4616 22.1646C14.765 21.5556 14.0961 20.9849 13.5052 20.4814L13.5021 20.479C13.5011 20.4783 13.5001 20.4775 13.4992 20.4767C11.8074 19.0349 10.3445 17.789 9.35706 16.5975C8.33555 15.3649 7.87469 14.2586 7.87469 13.0252C7.87469 11.8568 8.26769 10.7849 8.98374 10.0082C9.68935 9.24293 10.661 8.82092 11.7162 8.82092L11.7163 8.82091Z"
                            fill="white"
                        />
                      </svg>
                    </div>
                    <div class="finance">
                      <h6>Education</h6>
                      <svg
                          @click="toggleSphere('e')"
                          width="31"
                          height="31"
                          viewBox="0 0 31 31"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M15.5 31C24.0604 31 31 24.0604 31 15.5C31 6.93959 24.0604 0 15.5 0C6.93959 0 0 6.93959 0 15.5C0 24.0604 6.93959 31 15.5 31Z"
                            :fill="
                      formTool &&
                      formTool.spheres &&
                      formTool.spheres.includes('e')
                        ? '#65EA82'
                        : '#ddd'
                    "
                        />
                        <path
                            d="M10.1106 21.1949C9.85899 21.1949 9.65503 20.9909 9.65503 20.7393V10.0889C9.65503 9.05258 10.4982 8.20947 11.5345 8.20947H20.8885C21.1401 8.20947 21.344 8.41348 21.344 8.6651V19.1446C21.344 19.3962 21.1401 19.6002 20.8885 19.6002C20.6368 19.6002 20.4328 19.3962 20.4328 19.1446V9.12073H11.5345C11.0006 9.12073 10.5663 9.55506 10.5663 10.0889V20.7393C10.5663 20.9909 10.3623 21.1949 10.1106 21.1949V21.1949Z"
                            fill="white"
                        />
                        <path
                            d="M20.8885 22.7901H11.7054C10.5748 22.7901 9.65503 21.8703 9.65503 20.7398C9.65503 19.6092 10.5748 18.6895 11.7054 18.6895H20.8885C21.1401 18.6895 21.344 18.8935 21.344 19.1451C21.344 19.3967 21.1401 19.6007 20.8885 19.6007H11.7054C11.0773 19.6007 10.5663 20.1117 10.5663 20.7398C10.5663 21.3679 11.0773 21.8788 11.7054 21.8788H20.8885C21.1401 21.8788 21.344 22.0828 21.344 22.3345C21.344 22.5861 21.1401 22.7901 20.8885 22.7901V22.7901Z"
                            fill="white"
                        />
                        <path
                            d="M20.8886 21.1954H11.7055C11.4538 21.1954 11.2499 20.9914 11.2499 20.7398C11.2499 20.4882 11.4538 20.2842 11.7055 20.2842H20.8886C21.1402 20.2842 21.3442 20.4882 21.3442 20.7398C21.3442 20.9914 21.1402 21.1954 20.8886 21.1954Z"
                            fill="white"
                        />
                        <path
                            d="M12.1611 19.6002C11.9094 19.6002 11.7054 19.3962 11.7054 19.1445V8.6651C11.7054 8.41348 11.9094 8.20947 12.1611 8.20947C12.4127 8.20947 12.6167 8.41348 12.6167 8.6651V19.1445C12.6167 19.3962 12.4127 19.6002 12.1611 19.6002Z"
                            fill="white"
                        />
                      </svg>
                    </div>
                    <div class="finance">
                      <h6>Finance</h6>
                      <svg
                          @click="toggleSphere('f')"
                          width="31"
                          height="31"
                          viewBox="0 0 31 31"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M15.5 31C24.0604 31 31 24.0604 31 15.5C31 6.93959 24.0604 0 15.5 0C6.93959 0 0 6.93959 0 15.5C0 24.0604 6.93959 31 15.5 31Z"
                            :fill="
                      formTool &&
                      formTool.spheres &&
                      formTool.spheres.includes('f')
                        ? '#F6F28B'
                        : '#ddd'
                    "
                        />
                        <path
                            d="M11.226 8.40771C10.3024 8.41177 9.55279 9.15531 9.53763 10.0792H9.35966C8.42659 10.0792 7.6684 10.8333 7.66431 11.7664C7.66431 11.7665 7.66431 11.7666 7.66431 11.7666V20.8924C7.66431 20.8925 7.66431 20.8925 7.66431 20.8926C7.66839 21.8256 8.42237 22.5877 9.35948 22.5918H19.7737C20.6973 22.5877 21.4469 21.8441 21.4621 20.9202H21.64C22.5731 20.9202 23.3313 20.1661 23.3354 19.233C23.3354 19.233 23.3354 19.2329 23.3354 19.2328V10.107C23.3354 10.1069 23.3354 10.1068 23.3354 10.1068C23.3313 9.16996 22.5772 8.41181 21.6402 8.40772H11.226V8.40771ZM11.226 9.29902H11.2265H21.6403C22.0841 9.30298 22.4406 9.66321 22.4444 10.1073V12.0289L21.4652 13.2909V11.7666C21.4652 10.8334 20.7069 10.0792 19.7738 10.0792H10.4289C10.4437 9.64847 10.7918 9.3029 11.2261 9.29902H11.226ZM9.35948 10.9705H19.7737C20.2138 10.9705 20.5738 11.3229 20.5738 11.7666V14.0008C20.5183 14.0108 20.4625 14.0193 20.4105 14.0193H18.114C16.8385 14.0193 15.8019 15.056 15.8019 16.3315C15.8019 17.607 16.8384 18.6437 18.1139 18.6477H20.4063C20.4072 18.6477 20.4081 18.6477 20.4089 18.6477C20.4641 18.6447 20.5171 18.6383 20.5697 18.6325L20.5736 20.8925C20.5736 21.3363 20.2173 21.6965 19.7735 21.7004H9.35967H9.35921C8.91553 21.6965 8.55911 21.3363 8.55516 20.8924V11.7671V11.7666C8.55915 11.3268 8.91534 10.9705 9.35921 10.9705L9.35948 10.9705ZM22.4405 13.4856L22.4442 15.7621L21.2084 17.365C21.0186 17.6118 20.7219 17.7566 20.4099 17.7604H18.1143H18.1139C17.3277 17.7564 16.693 17.1215 16.693 16.3354C16.693 15.5494 17.3277 14.9146 18.1139 14.9106H20.4063C20.6876 14.9106 20.9652 14.8495 21.2186 14.727L21.219 14.7268C21.4886 14.6001 21.725 14.4084 21.9085 14.1718V14.1718L22.4405 13.4856ZM18.0504 15.8898C17.8055 15.8898 17.6048 16.0905 17.6048 16.3354C17.6048 16.5804 17.8055 16.7811 18.0504 16.7811H19.0055C19.2504 16.7811 19.4512 16.5804 19.4512 16.3354C19.4512 16.0905 19.2504 15.8898 19.0055 15.8898H18.0504ZM22.4443 17.219V19.2328C22.4402 19.6727 22.0841 20.0289 21.6402 20.0289H21.4651V18.3165C21.6315 18.2011 21.7833 18.0617 21.9118 17.906C21.9121 17.9056 21.9124 17.9052 21.9127 17.9048L22.4443 17.219Z"
                            fill="white"
                        />
                      </svg>
                    </div>
                  </div>
                </b-form-group>
              </div>
            </b-tab>

            <!-- ABOUT & INTRO -->
            <b-tab title="About & Intro">
              <div>
                <!-- Intro -->
                <b-form-group
                    v-if="formTool && formTool.aboutIntro"
                    label="Intro" label-for="intro"
                >
                  <b-form-textarea
                      id="intro"
                      v-model="formTool.aboutIntro.intro"
                      placeholder="Description"
                      rows="2"
                      no-resize
                  />
                </b-form-group>
                <!-- About -->
                <b-form-group
                    v-if="formTool && formTool.aboutIntro"
                    label="about" label-for="about"
                >
                  <b-form-textarea
                      id="about"
                      v-model="formTool.aboutIntro.about"
                      placeholder="Description"
                      rows="2"
                      no-resize
                  ></b-form-textarea>
                </b-form-group>
                <template v-if="formTool && formTool.policyURLS">
                  <b-form-group
                      label="Terms and Conditions Policy Url (Opt)"
                  >
                    <b-form-input
                        v-model="formTool.policyURLS.terms"
                        type="text"
                        required
                        placeholder="Enter T&C Policy URL"
                    />
                  </b-form-group>
                  <b-form-group
                      label="Privacy Policy Url (Opt)"
                  >
                    <b-form-input
                        v-model="formTool.policyURLS.privacy"
                        type="text"
                        required
                        placeholder="Enter Privacy Policy URL"
                    />
                  </b-form-group>
                  <b-form-group
                      label="Data Policy Url (Opt)"
                  >
                    <b-form-input
                        v-model="formTool.policyURLS.data"
                        type="text"
                        required
                        placeholder="Enter Data Policy URL"
                    />
                  </b-form-group>
                </template>
                <hr />
                <b-form-group
                    v-if="formTool && formTool.aboutIntro"
                    label="Tutorial Video"
                >
                  <b-form-input
                      v-model="formTool.aboutIntro.videos.tutorial"
                      type="text"
                      required
                      placeholder="Enter Tutorial Video URL"
                  />
                </b-form-group>
                <b-form-group
                    v-if="formTool.emails"
                    label="Support Email"
                >
                  <b-form-input
                      v-model="formTool.emails.support"
                      type="text"
                      required
                      placeholder="Enter Support Email"
                  />
                </b-form-group>
                <b-form-group
                    label="Copyright"
                >
                  <b-form-input
                      v-model="formTool.copyrightYear"
                      type="text"
                      required
                      placeholder="2023"
                  />
                </b-form-group>
              </div>
            </b-tab>

            <!--MAIL -->
            <b-tab title="Mail">
              <div>
                <b-tabs pills card vertical>
                  <b-tab title="Intro" active>
                    <div
                        v-if="formTool && formTool.mail && formTool.mail.intro"
                    >
                      <div>
                        <!-- Action Tagline -->
                        <b-form-group
                            label="Tag Line"
                            label-for="action-tagline"
                        >
                          <b-form-textarea
                              id="action_tagline"
                              v-model="formTool.mail.intro.actionTagline"
                              placeholder="Make long lasting Memories with Your Family"
                              rows="2"
                              no-resize
                          ></b-form-textarea>
                        </b-form-group>

                        <b-form-group label="Statement" label-for="action-statement">
                          <b-form-textarea
                              id="action-statement"
                              v-model="formTool.mail.intro.actionStatement"
                              placeholder="Memories is the best way to share those special moments of years past"
                              rows="2"
                              no-resize
                          ></b-form-textarea>
                        </b-form-group>
                        <b-form-group label="Tutorial Video" label-for="video-tutorial">
                          <b-form-textarea
                              id="video-tutorial"
                              v-model="formTool.mail.intro.videoTutorial"
                              placeholder="https://yourtube.com/myvideo"
                              rows="1"
                              no-resize
                          ></b-form-textarea>
                        </b-form-group>
                        <b-form-group label="Feature Title 1" label-for="feature-title1">
                          <b-form-textarea
                              id="feature-title1"
                              v-model="formTool.mail.intro.feature1Title"
                              placeholder="AI Photo Editing"
                              rows="2"
                              no-resize
                          ></b-form-textarea>
                        </b-form-group>
                        <b-form-group label="Feature Blurb 1" label-for="feature-blurb1">
                          <b-form-textarea
                              id="feature-blurb1"
                              v-model="formTool.mail.intro.feature1Blurb"
                              placeholder="Make long lasting Memories with Your Family"
                              rows="2"
                              no-resize
                          ></b-form-textarea>
                        </b-form-group>
                        <b-form-group label="Feature Title 2" label-for="feature-title1">
                          <b-form-textarea
                              id="feature-title1"
                              v-model="formTool.mail.intro.feature2Title"
                              placeholder="Make long lasting Memories with Your Family"
                              rows="2"
                              no-resize
                          ></b-form-textarea>
                        </b-form-group>
                        <b-form-group label="Feature Blurb 2" label-for="feature-blurb2">
                          <b-form-textarea
                              id="feature-blurb2"
                              v-model="formTool.mail.intro.feature2Blurb"
                              placeholder="Make long lasting Memories with Your Family"
                              rows="2"
                              no-resize
                          ></b-form-textarea>
                        </b-form-group>
                        <b-form-group
                            label="Feature Title 3"
                            label-for="feature-title3">
                          <b-form-textarea
                              id="feature-title3"
                              v-model="formTool.mail.intro.feature3Title"
                              placeholder="Make long lasting Memories with Your Family"
                              rows="2"
                              no-resize
                          ></b-form-textarea>
                        </b-form-group>
                        <b-form-group
                            label="Feature Blurb 3"
                            label-for="feature-blurb3">
                          <b-form-textarea
                              id="action_tagline"
                              v-model="formTool.mail.intro.feature3Blurb"
                              placeholder="Make long lasting Memories with Your Family"
                              rows="2"
                              no-resize
                          ></b-form-textarea>
                        </b-form-group>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="Notifiation">
                    <b-card-text>
                      Tab contents 2
                    </b-card-text></b-tab>
                  <b-tab title="Survey">
                    <b-card-text>Tab contents 3</b-card-text></b-tab>
                </b-tabs>
              </div>
            </b-tab>

          </b-tabs>

          <!--Status -->
          <b-form-group label="View Status">
            <b-form-select
                v-model="formTool.status"
                :options="statusOptions"
            ></b-form-select>
          </b-form-group>

          <!--App Type -->
          <b-form-group label="Tool Type">
            <b-form-select
                v-model="formTool.toolType"
                :options="toolTypeOptions"
            ></b-form-select>
          </b-form-group>

          <div class="d-flex justify-content-between">
            <b-button
                variant="primary"
                v-if="mode === 'add'"
                @click="handleAddClick"
                :disabled="
                formTool.name &&
                formTool.name.trim().length > 0 &&
                formTool.status !== null
                  ? false
                  : true
              "
            >
              Add
            </b-button>
            <b-button
                v-else-if="mode==='edit'"
                variant="primary"
                @click="handleUpdateClick"
                :disabled="formTool.status !== null ? false : true"
            >
              Update
            </b-button>
          </div>
        </div>
        <div v-else class="add-tool del-user">
          <span class="close-icon" @click="handleCancel">
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
              <g clip-path="url(#clip0)">
                <path
                    d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                    fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                      width="10.6667"
                      height="10.6667"
                      fill="white"
                      transform="translate(6.6665 6.66675)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <h3>Delete Tool</h3>
          <div class="warning-msg">
            <p>
              Are you sure you want to delete
              <strong>
                {{
                  tool && tool.name ? tool.name : "this"
                }}
              </strong>?
            </p>
          </div>
          <div class="d-flex justify-content-between">
            <b-button variant="danger btn-round-fill" @click="handleDeleteToolClick">
              Yes! Delete
            </b-button>
            <b-button variant="light btn-simple" @click="handleCancel">
              No! back
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>
    <vimeo-modal
        v-if="formTool && formTool.video && formTool.video.videoId"
        :id="toolVideo"
        :videoId="formTool.video.videoId"
        :videoThumb="formTool.video.videoThumb ? formTool.video.videoThumb : null"
    />
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import moment from "moment";
import firebase from "firebase";
import TimeAgo from "vue2-timeago";
import MyUpload from "vue-image-crop-upload";
import UploadImage from "@/mixins/UploadImage";
import VideoHandling from "@/mixins/VideoHandling";
import VimeoModal from "@/components/common/vimeoModal";

export default {
  name: "Admin_Tools_AddEdit",
  props: {
    toolModalId: {
      type: String,
      default: null
    },
    tool: {
      type: Object,
      default: () => {
        return {}
      }
    },
    mode: {
      type: String,
      default: null
    }
  },
  components: {
    TimeAgo,
    MyUpload,
    VimeoModal
  },
  mixins: [UploadImage, VideoHandling],
  computed: {
    ...mapGetters({
      profile: "user/profile",
      allCompanies: "admin/companies"
    })
  },
  mounted() {
    this.resetForm();
  },
  methods: {
    handleModalOpened(){
      this.resetForm();
      //check mode
      if (this.mode ==='edit' && this.tool){
        Object.keys(this.formTool).forEach(key => {
          if (this.tool.hasOwnProperty(key)) {
            this.formTool[key] = this.tool[key];
          }
        });
      } else if (this.mode ==='add' && this.tool){

        Object.keys(this.formTool).forEach(key => {
          if (this.tool.hasOwnProperty(key)) {
            this.formTool[key] = this.tool[key];
          }
        });
      }
      //check if it has a tool
      //check mode of edit|add|delete

    },
    handleCancel() {
      this.$bvModal.hide(this.toolModalId);
      let imagesToRemove = [];
      if (this.mode === 'add') {
        if (this.formTool.imgURL) {
          let name = this.getImageNameFromUrl(this.formTool.imgURL);
          imagesToRemove.push(name);
        }
        if (this.formTool.images.length > 0) {
          this.formTool.images.forEach(imgURL => {
            let name = this.getImageNameFromUrl(imgURL);
            imagesToRemove.push(name);
          });
        }
        imagesToRemove.forEach(image => {
          const fileRef = firebase.storage().ref(`tool_img/${image}`);
          fileRef
              .delete()
              .then(() => {
                console.log("Image has been deleted");
              })
              .catch(error => {
                console.log(error);
              });
        });
      }
    },
    showMore(id) {
      this.$set(this.readMore, id, true);
    },
    showLess(id) {
      this.$set(this.readMore, id, false);
    },
    getStatus(status) {
      if (status == "active") {
        return "Active";
      } else return "In Active";
    },
    getStatusColor(status) {
      if (status == "active") {
        return "#4BB543";
      } else return "#FF0000";
    },
    formatDate(date) {
      return date
        ? moment(date.toDate()).format("MMMM DD, YYYY h:MM a")
        : "N/A";
    },
    toggleSphere(e) {
      if (this.formTool.spheres.includes(e)) {
        let index = this.formTool.spheres.indexOf(e);
        this.formTool.spheres.splice(index, 1);
      } else {
        this.formTool.spheres.push(e);
      }
    },
    associateCompany(company) {
      this.formTool.company = {
        companyId: company.companyId,
        name: company.company.name,
        email: company.company.email,
        imgURL: company.company.imgURL
      };
      this.$refs.companiesDropdown.hide(true);
    },
    getCompanyText() {
      let text = "Companies";
      this.allCompanies.forEach(element => {
        if (this.formTool.company) {
          if (element.companyId == this.formTool.company.companyId) {
            if (element.company.name) {
              text = element.company.name;
            } else {
              text = element.companyId;
            }
          }
        }
      });
      return text;
    },
    resetForm() {
      this.formTool = _.clone(this.formToolDefault);
    },
    handleAddClick() {
      this.$store
        .dispatch("admin/addNewTool", {
          tool: this.formTool,
          createdBy:  this.profile ?{
            uid: this.profile.userId,
            imgURL: this.profile.imgURL,
            name: `${this.profile.firstname} ${this.profile.lastname}`
          } : ''
        })
        .then(res => {
          this.$bvModal.hide(this.toolModalId);
          this.resetForm();
          this.getTools();
        });
    },
    handleUpdateClick() {
      this.$store
        .dispatch("admin/updateTool", {
          tool: this.formTool,
          toolId: this.tool && this.tool.toolId ? this.tool.toolId : null,
          updatedBy:  this.profile ? {
            uid: this.profile.userId,
            imgURL: this.profile.imgURL,
            name : `${this.profile.firstname} ${this.profile.lastname}`
          }:''
        })
        .then(res => {
          debugger;
          const  message = {
            title:`${this.formTool.name} Succesfully Updated`,
            descriptions:`You updated 5 fields`,
            variant:`success`
          };
          this.$store.dispatch("user/showNotification", {
            title: message.title,
            description: message.description,
            variant: message.variant
          });
          this.handleCancel();
          this.resetForm();
          this.$emit('tool-updated', this.formTool);
        });
    },
    handleDeleteToolClick() {
      this.$store
        .dispatch("admin/deleteTool", {
          toolId: this.tool.toolId,
          deletedBy: this.profile ? {
            uid: this.profile.userId,
            imgURL: this.profile.imgURL,
            name: `${this.profile.firstname} ${this.profile.lastname}`
          } : ''
        })
        .then(res => {
          this.$bvModal.hide(this.toolModalId);
          this.resetForm();
          this.getResources();
        });
    },
    playToolVideo() {
      if (
        this.formTool.video &&
        this.formTool.video.videoId &&
        this.formTool.video.videoThumb
      )
        this.$bvModal.show(this.toolVideo);
    },
    getImageNameFromUrl(url) {
      let name = url.substr(
        url.indexOf("%2F") + 3,
        url.indexOf("?") - (url.indexOf("%2F") + 3)
      );
      name = name.replace("%20", " ");
      return name;
    },
    cropSuccess(imgDataUrl) {
      this.handleUploadImage(imgDataUrl);
    },
    cropUploadSuccess(jsonData, field) {
      console.log(jsonData);
      console.log("field: " + field);
    },
    cropUploadFail(status, field) {
      console.log(status);
      console.log("field: " + field);
    },
    uploadIcon() {
      this.showUpload = true;
      this.imgToUpload = "icon";
    },
    uploadScreen() {
      this.showUpload = true;
      this.imgToUpload = "screen";
    },
    handleUploadImage(imgDataUrl) {
      switch (this.imgToUpload) {
        case "icon":
          this.uploadingIcon = true;
          this.uploadToolImage(imgDataUrl)
            .then(imgURL => {
              this.uploadingIcon = false;
              this.formTool.imgURL = imgURL;
            })
            .catch(e => {
              this.uploadIcon = false;
            });
          break;
        case "screen":
          this.uploadingScreen = true;
          this.uploadToolImage(imgDataUrl)
            .then(imgURL => {
              this.uploadingScreen = false;
              this.formTool.images.push(imgURL);
            })
            .catch(e => {
              this.uploadingScreen = false;
            });
          break;
        default:
          return;
      }
    },
    triggerChooseVideo() {
      document.getElementById("tool-video").click();
    },
    uploadToolVideo(event) {
      let file = event.target.files[0];
      let name = `tool_videoe_${this.profile.userId}_${(Date.now() / 1000) |
        0}`;
      let description = `${this.profile.firstname} uploaded tool video.`;
      this.uploadVideo(file, name, description).then(video => {
        this.getThumbnail(video);
      });
    },
    getThumbnail(video) {
      this.processingVideo = true;
      this.getVideoThumbnail(video.videoId)
        .then(thumbnail => {
          this.formTool.video = {
            _created_at: new Date(),
            ...video,
            videoThumb: thumbnail
          };
          this.processingVideo = false;
        })
        .catch(e => {
          this.processingVideo = false;
          console.log(e);
        });
    },
  },
  data() {
    return {
      add: true,
      formTool : {},
      formToolDefault: {
        name: "",
        profileNameId:"",
        inspiredBy:"",
        description: "",
        emails:{
          support: null,
          marketing:null,
          contact:null
        },
        videos:{
          tutorial:null,
          marketing:[]
        },
        credits:[],
        versionNumber: null,
        versionHistory: null,
        company: null,
        imgURL: null,
        price: null,
        rating: null,
        ratingLevel: null,
        images: [],
        spheres: [],
        status: null,
        toolType: null,
        aboutIntro:{
          intro: null,
          about:null,
          videos:{
            tutorial:null
          }
        },
        mail:{
          intro: {
            actionTagline:'',
            actionStatement:'',
            videoTutorial:'',//Create a list of prioritized projects to be shown in the sidebar.
            feature1Title:'',
            feature1Blurb:'',
            feature2Title:'',
            feature2Blurb:'',
            feature3Title:'',
            feature3Blurb:'',
          },
        },
        version:{
          number:null,
          history:[]
        },
        copyrightYear: null,
        policyURLS:{
          term:null,
          privacy:null,
          data:null
        }
      },
      formMailIntro: {
        actionTagline:'',
        actionStatement:'',
        videoTutorial:'',//Create a list of prioritized projects to be shown in the sidebar.
        feature1Title:'',
        feature1Blurb:'',
        feature2Title:'',
        feature2Blurb:'',
        feature3Title:'',
        feature3Blurb:'',
      },
      isBusy: false,
      readMore: {},
      toolVideo: "tool-video",
      searchStr: "",
      input: "",
      imgDataUrl: "",
      imgToUpload: null,
      uploadingIcon: false,
      uploadingScreen: false,
      processingVideo: false,
      activeIndex: -1,
      selectedTool: null,
      statusOptions: [
        //@TODO - Move to Mixin
        { value: null, text: "Please select an option" },
        { value: "active", text: "Active" },
        { value: "inactive", text: "Inactive" }
      ],
      toolTypeOptions: [
        //@TODO - Move to Mixin and use new Drop down
        { value: null, text: "Please select an app type" },
        { value: "myapp", text: "MyApp" },
        { value: "service", text: "Service" }
      ],
      showUpload: false,
      params: {
        token: "123456798",
        name: "avatar"
      },
      headers: {
        smail: "*_~"
      },
      transProps: {
        name: "flip-list" // Transition name
      }
    };
  },
};
</script>

<style lang="scss" scoped>
.add-tool {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: black;
  cursor: pointer;
  position: relative;
}
.add-tool {
  .close-icon {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
  .btn-round-fill {
    max-width: 160px;
    width: 100%;
  }
  .upload-btn {
    margin: 10px;
  }
  input {
    margin-top: 5px;
    margin-bottom: 10px;
  }
  h3 {
    margin-bottom: 0;
    margin-top: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 33px;
    color: #474d52;
    text-align: center;
  }
}
.del-user {
  .warning-msg {
    margin: 24px 0;
    p {
      text-align: center;
      margin: 0;
    }
  }
  .btn-round-fill {
    background-color: #ef5c4a;
    border-color: #ef5c4a;
  }
  .btn-simple {
    color: #ef5c4a;
    font-weight: bold;
  }
}

.search {
  cursor: pointer;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
}
.card-tool {
  box-shadow: none;
}
.resources {
  margin-top: 20px;
  .card {
    border: none;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    .card-text {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      display: flex;
      align-items: center;
      color: #474d52;
    }
  }

  .card-header {
    display: grid;
    grid-template-columns: 1fr 30px;
    align-items: center;
    padding: 0;
    .edit,
    .delete {
      display: none;
      cursor: pointer;
    }
    .btn-collapse {
      padding: 24px;
      text-align: left;
      box-shadow: none;
    }
    &.active {
      grid-template-columns: 1fr 30px 30px 30px;
      .edit,
      .delete {
        display: block;
      }
      .btn-collapse {
        padding-bottom: 0px;
      }
    }

    border: none;
    box-shadow: none;
    background: none;
  }
}
.actions {
  display: flex;
  justify-content: space-evenly;
}
.status {
  margin-top: 0.5rem;
  display: flex;
  flex-direction: column;
  .status-btn {
    display: inline-block;
    margin-right: 15px;
    width: 105px;
    height: 21px;
    font-family: Nunito;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #ffffff;
    background: var(--theme-color);
    text-align: center;
    border: none;
    border-radius: 3px;
  }
}
.tool-image {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}
.areas {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  & > div {
    width: 60px;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #8d99a0;
    }
    svg {
      cursor: pointer;
    }
  }
}
#description {
  border-radius: 5px;
}
#tool-video {
  visibility: hidden;
  position: absolute;
}
.inline-form {
  display: flex;
  justify-content: space-around;
}
.tool-images {
  display: flex;
  flex-wrap: wrap;
  .tool-image {
    margin-left: 15px;
    width: 115px;
    height: 170px;
    border-radius: 5px;
  }
}
.companies {
  cursor: pointer;
  padding: 5px 15px;
  border-bottom: 1px solid #000;
  width: 250px;
  span {
    font-weight: bold;
  }
  .company-image {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 20px;
  }
}
.tool-video {
  width: 250px;
  height: 185px;
  border-radius: 15px;
}
</style>
